__turbopack_context__.v({
  "currency": "currency-formater-module-sass-module__8LTIaW__currency",
});
